export default __webpack_public_path__ + "static/media/loader.97c30d50.gif";